import CompanyDetails from './CompanyDetails';

export default {
  title: 'Company Details',
  description:
    'Please fill in following details, so that these can be used on the Sales documents.',
  path: '/setup/company',
  component: CompanyDetails,
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'Company Details' }],
  buttons: {
    close: {},
    next: {},
  },
};
